import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import '../../../assets/css/views/activities/activities.css';
import BackButton from "../../../features/path/backButton";
import { IActivityDto } from "../../../models/dto/agendaApi/IActivityDto";
import activitiesService from "../../../services/agendaApi/activities.service";
import { useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import activitiesIcons from "../../../utils/maps/activitiesIcons";
import { ProgressIndicator } from "@veneer/core";
import activitiesRoutes from "../../../utils/maps/activitiesRoutes";
import { BreadCrumbsEnum } from "../../../models/enum/BreadCrumbsEnum";
import { decryptText } from "../../../utils/encryptionUtils";
import { CountryEnum } from "../../../models/enum/CountryEnum";

export default function ActivitiesByAppointment() {
  const params = useParams();
  const [t] = useTranslation("global");
  const [activities, setActivities] = useState<IActivityDto[]>([])
  const navigate = useNavigate();
  const [showLoading, setShowLoading] = useState(false);
  const [appointmentId, setAppointmentId] = useState(0);
  const languageId: any = useSelector((state: RootState) => state.languageId);
  const state: any = useSelector((state: RootState) => state.user);
  const [country, setCountry] = useState(NaN);


  useEffect(() => {
    setShowLoading(true);
    let id = Number(params.id);
    setAppointmentId(id);
    setCountry(Number(decryptText(state.user.countryId)))
  }, []);

  useEffect(() => {
    if (appointmentId > 0 && languageId.value > 0) {
      getActivities();
    }
  }, [languageId, appointmentId])

  const getActivities = () => {
    activitiesService.getActivitiesByAppointment(appointmentId, languageId.value)
      .then((r: IActivityDto[]) => {
        const responseSort = r.sort((a:any, b:any) => a.id - b.id);
        if(country === CountryEnum.brasil1 || country === CountryEnum.brasil2 || country === CountryEnum.brasil3){
          setActivities(responseSort.filter(activity => activity.activityID != 14  && activity.activityID != 18));
        }else if(country === CountryEnum.colombia1 || country === CountryEnum.colombia2 || country === CountryEnum.colombia3){
          setActivities(responseSort.filter(activity => activity.activityID != 3 && activity.activityID != 9 && activity.activityID != 18));
        }else {
          setActivities(responseSort.filter(activity => activity.activityID != 3 && activity.activityID != 9 && activity.activityID != 14  && activity.activityID != 18));
        }
      }).finally(() => {
        setShowLoading(false)
      })
  }

  // const getActivitiesDate = () => {
  //   syncService.getActivitiesDate()
  //     .then((r: any) => {
  //       fillDates(r);
  //     }).finally(() => {
  //       setShowLoading(false)
  //     })
  // }
  // <span style={{ float: "right" }}>{!activity.activityFlag ? <IconCheckmarkCircle/> : null}</span>
  // {activity.activityDate ? <p>{String(moment(activity.activityDate).utc().format('DD/MM/YYYY'))}</p> : <p>DD/MM/YYYY</p>}


  // const fillDates = (dataDates: IActivityDateDto[]) => {
  //   const activitiesTemp = activities;
  //   for (let i = 0; i < activitiesTemp.length; i++) {
  //     let item = dataDates.find(item => item.activityID === activitiesTemp[i].activityID);
  //     if (item) { activitiesTemp[i].activityDate = item.activityDate }
  //   }
  //   setActivities([...activitiesTemp])
  // }

  const goToActivity = (activityId: number, appointmentActivityID: number) => {
    navigate(`/${activitiesRoutes.get(activityId)}/${appointmentActivityID}/${appointmentId}`);
  }

  return (
    <div>
      <div style={{ padding: '20px' }}>
        <BackButton route={BreadCrumbsEnum.Activities} activityId={appointmentId} />
        <h4>{t("header.activities")}</h4>
        <div style={{ padding: '20px' }}>
          {showLoading ?
            <div className="container">
              <div className="vertical-center">
                <ProgressIndicator
                  appearance="circular"
                  behavior="indeterminate"
                />
              </div>
            </div>
            :
            <div id="container">
              <div id="inner">
                {
                  activities.map(activity =>
                    <div key={activity.activityID} className="child" onClick={() => goToActivity(activity.activityID, activity.appointmentActivityID)}>
                      <div className="square" style={{ border: `3px solid #${activity.activityColor}`, textAlign: 'center' }}>
                        <div style={{ margin: '10px' }}>
                          <div style={{ textAlign: 'center'}}>
                            <h6 style={{ height: "auto" }}>{activity.activityName}</h6>
                          </div>
                          <div style={{ margin: '15px' }}>
                            {activitiesIcons?.get(activity.activityID)}
                          </div>
                          <div style={{ textAlign: 'right' }}>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  );
}